import { PartnerState, PartnerTypes, PartnerActionTypes } from './types'
import { Reducer } from 'redux'

const initialState: PartnerState = {
  partnerList: { items: [] }
}

type ReducerOpts = Reducer<PartnerState, PartnerActionTypes>
const reducer: ReducerOpts = (state = initialState, action: PartnerActionTypes): PartnerState => {
  let index = -1
  switch (action.type) {
    case PartnerTypes.PARTNER_CREATE:
      return {
        ...state,
        partnerList: { ...state.partnerList, items: [action.payload, ...state.partnerList.items] }
      }
    case PartnerTypes.PARTNER_UPDATE:
      index = state.partnerList.items.findIndex(item => item.id === action.payload.id)
      return {
        ...state,
        partner: action.payload,
        partnerList: {
          ...state.partnerList,
          items: [
            ...state.partnerList.items.slice(0, index),
            action.payload,
            ...state.partnerList.items.slice(index + 1)
          ]
        }
      }
    case PartnerTypes.PARTNER_DELETE:
      index = state.partnerList.items.findIndex(item => item.id === action.payload)
      return {
        ...state,
        partnerList: {
          ...state.partnerList,
          items: [
            ...state.partnerList.items.slice(0, index),
            ...state.partnerList.items.slice(index + 1)
          ]
        }
      }
    case PartnerTypes.PARTNER_GET:
      return { ...state, partner: action.payload }
    case PartnerTypes.PARTNER_LIST:
      return { ...state, partnerList: { items: action.payload, pagination: action.pagination } }
    default:
      return state
  }
}

export default reducer
